import React, {Component, ReactElement, ReactNode} from 'react'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {NatGetRoomToResidentDetails} from '../roomToResident/repository/NatGetRoomToResidentDetails'
import {NatPutRoomToResident, NatPutRoomToResidentParams} from '../roomToResident/repository/NatPutRoomToResident'
import {
    ADMINISTORATOR_MODE,
    AVAILABLE_OR_NOT,
    HAVE_OR_NOT,
    MAIL_MAGAZINE_RECEIVING_DO_OR_NOT,
    MESSAGE_TYPE,
    NOTIFICATION_DO_OR_NOT,
    RESIDENT_STATUS,
    ROLE_FOR_RESIDENT,
    SEX_MASTER,
} from '../../../CodeMaster'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Messages} from '../../../Messages'
import {Nullable} from '../../../app/TypeHelpers'
import {StyledTableCaption, TableRowName, TableRowNameTop} from '../../../styledComponents/adminPage/Table'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {formatForDateInput} from '../../../formatters/formatDate'
import {NatGetCondominium} from '../condominium/repository/NatGetCondominium'
import {ConditionTableFixed} from '../../../styledComponents/adminPage/ConditionTable'
import {
    autoKanaOnUpdate,
    getAcceptedWarningList,
    getStringOrEmptyString,
    setHighlightingWarningList
} from '../../common/util/Natutil'
import NatAdminCommonAcceptedWarningComponent from '../common/admin/NatAdminCommonAcceptedWarningComponent'
import {AcceptedWarning, Warning} from '../common/admin/NatAcceptedWarning'
import {createRejectionResidentUserRegistrationApplyInfoMessage} from './NatAdminResidentUserHelper'
import {Box, TableBody, TableCell, TableRow} from '@mui/material';
import styled from 'styled-components'
import {
    AdminLoginInfoSessionStorageKey,
    NatAdminLoginInfoSessionStorageHelper,
} from '../../common/authentication/NatAdminLoginInfoSessionStorageHelper'
import {Location} from 'react-router-dom'

const highlightingMessegIdList: string[] = [Messages.WRESA0006.id]

interface Props {
    condominiumCd: string
    ridgeCd: string
    roomNumber: string
    seq: string
    roomToResidentRepo: NatRoomToResidentRepo
    condominiumRepo: NatCondominiumRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    roomToResidentDetails: NatGetRoomToResidentDetails
    mainUserFlag: boolean
    isLoadCompleted: boolean
    selectedRole: string
    cardKeyNumber: string
    familyName: string
    firstName: string
    familyNameKana: string
    firstNameKana: string
    sex: string
    birthday: string
    mailAddressPc: string
    mailAddressMb: string
    password: string
    passwordConfirm: string
    sutekiNetOfNotice: string
    adminFamilyName: string
    adminFirstName: string
    adminFamilyNameKana: string
    adminFirstNameKana: string
    validPeriodStartDate: string
    validPeriodEndDate: string
    bulletinBoardCommentNotice: string
    billingAmountFixNotice: string
    facilityReserveAvailability: string
    memo: string
    authenticationKey: string
    registerButtonDisabled: boolean
    passwordPlaceholder: boolean
    selectedCondominiumCardKey: string
    editUser: EditUserType
    acceptAll: boolean
    acceptedWarning: AcceptedWarning[]
    warnings: Warning[]
    convertFamilyNameKana: string
    preFamilyNameKana: string
    convertFirstNameKana: string
    preFirstNameKana: string
    convertAdminFamilyNameKana: string
    preAdminFamilyNameKana: string
    convertAdminFirstNameKana: string
    preAdminFirstNameKana: string
}

type EditUserType = 'unRegisteredNotHasekoId' | 'unRegisteredHasekoId' | 'registered'

type inputOrSelectState =
    'selectedRole'
    | 'cardKeyNumber'
    | 'familyName'
    | 'firstName'
    | 'familyNameKana'
    | 'firstNameKana'
    | 'sex'
    | 'birthday'
    | 'mailAddressPc'
    | 'mailAddressMb'
    | 'password'
    | 'passwordConfirm'
    | 'adminFamilyName'
    | 'adminFirstName'
    | 'adminFamilyNameKana'
    | 'adminFirstNameKana'
    | 'sutekiNetOfNotice'
    | 'bulletinBoardCommentNotice'
    | 'billingAmountFixNotice'
    | 'facilityReserveAvailability'
    | 'memo';

class NatAdminResidentUserEditPage extends Component<Props & AdminPagePropsSet, States> {
    administratorMode: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.administratorMode = NatAdminLoginInfoSessionStorageHelper
            .getStringItemOrNull(AdminLoginInfoSessionStorageKey.SELECTED_MODE)

        this.state = {
            roomToResidentDetails: {
                details: null,
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            mainUserFlag: false,
            isLoadCompleted: false,
            selectedRole: ROLE_FOR_RESIDENT.RESIDENT.value,
            cardKeyNumber: '',
            familyName: '',
            firstName: '',
            familyNameKana: '',
            firstNameKana: '',
            sex: '',
            birthday: '',
            mailAddressPc: '',
            mailAddressMb: '',
            password: '',
            passwordConfirm: '',
            adminFamilyName: '',
            adminFirstName: '',
            adminFamilyNameKana: '',
            adminFirstNameKana: '',
            validPeriodStartDate: '',
            validPeriodEndDate: '',
            sutekiNetOfNotice: '',
            bulletinBoardCommentNotice: '',
            billingAmountFixNotice: '',
            facilityReserveAvailability: '',
            authenticationKey: '',
            registerButtonDisabled: true,
            passwordPlaceholder: true,
            selectedCondominiumCardKey: HAVE_OR_NOT.NOT.value,
            editUser: 'unRegisteredHasekoId',
            acceptAll: false,
            acceptedWarning: [],
            warnings: [],
            memo: '',
            convertFamilyNameKana: '',
            preFamilyNameKana: '',
            convertFirstNameKana: '',
            preFirstNameKana: '',
            convertAdminFamilyNameKana: '',
            preAdminFamilyNameKana: '',
            convertAdminFirstNameKana: '',
            preAdminFirstNameKana: '',
        }
        this.setInputOrSelectState = this.setInputOrSelectState.bind(this)
        this.onChangecardKeyNumber = this.onChangecardKeyNumber.bind(this)
        this.onChangeBirthday = this.onChangeBirthday.bind(this)
        this.onChangefamilyName = this.onChangefamilyName.bind(this)
        this.onChangefirstName = this.onChangefirstName.bind(this)
        this.onChangefamilyNameKana = this.onChangefamilyNameKana.bind(this)
        this.onChangefirstNameKana = this.onChangefirstNameKana.bind(this)
        this.onChangeMailAddressPc = this.onChangeMailAddressPc.bind(this)
        this.onChangeMailAddressMb = this.onChangeMailAddressMb.bind(this)
        this.onChangepassword = this.onChangepassword.bind(this)
        this.onChangepasswordConfirm = this.onChangepasswordConfirm.bind(this)
        this.onChangeadminFamilyName = this.onChangeadminFamilyName.bind(this)
        this.onChangeadminFirstName = this.onChangeadminFirstName.bind(this)
        this.onChangeadminFamilyNameKana = this.onChangeadminFamilyNameKana.bind(this)
        this.onChangeadminFirstNameKana = this.onChangeadminFirstNameKana.bind(this)
        this.onChangeValidPeriodStartDate = this.onChangeValidPeriodStartDate.bind(this)
        this.onChangeValidPeriodEndDate = this.onChangeValidPeriodEndDate.bind(this)
        this.onChangeSelectRole = this.onChangeSelectRole.bind(this)
        this.onChangeSelectSex = this.onChangeSelectSex.bind(this)
        this.onChangeSelectSutekiNetOfNotice = this.onChangeSelectSutekiNetOfNotice.bind(this)
        this.onChangeBulletinBoardCommentNotice = this.onChangeBulletinBoardCommentNotice.bind(this)
        this.onChangeBillingAmountFixNotice = this.onChangeBillingAmountFixNotice.bind(this)
        this.onChangeSelectFacilityReserveAvailability = this.onChangeSelectFacilityReserveAvailability.bind(this)
        this.onChangeSelectFacilityReserveAvailability = this.onChangeSelectFacilityReserveAvailability.bind(this)
        this.onChangeMemo = this.onChangeMemo.bind(this)
        this.onChangeAcceptedWarnings = this.onChangeAcceptedWarnings.bind(this)
        this.registerResidentUser = this.registerResidentUser.bind(this)
        this.residentUserListLinkClick = this.residentUserListLinkClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.onCompositionStartFamilyName = this.onCompositionStartFamilyName.bind(this)
        this.onCompositionUpdateFamilyName = this.onCompositionUpdateFamilyName.bind(this)
        this.onCompositionStartFirstName = this.onCompositionStartFirstName.bind(this)
        this.onCompositionUpdateFirstName = this.onCompositionUpdateFirstName.bind(this)
        this.onCompositionStartAdminFamilyName = this.onCompositionStartAdminFamilyName.bind(this)
        this.onCompositionUpdateAdminFamilyName = this.onCompositionUpdateAdminFamilyName.bind(this)
        this.onCompositionStartAdminFirstName = this.onCompositionStartAdminFirstName.bind(this)
        this.onCompositionUpdateAdminFirstName = this.onCompositionUpdateAdminFirstName.bind(this)
    }


    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 部屋居住者取得
            const roomToResidentDetails: Nullable<NatGetRoomToResidentDetails> = await this.props.asyncCallFunction(
                this.props.roomToResidentRepo.getRoomToResidentDetails.bind(this.props.roomToResidentRepo,
                    this.props.condominiumCd, this.props.ridgeCd, this.props.roomNumber, this.props.seq),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (roomToResidentDetails && roomToResidentDetails.details) {
                const mainUserFlag: boolean = !roomToResidentDetails.details.parentResidentId
                let registerButtonDisabled: boolean
                let editUser: EditUserType

                if (roomToResidentDetails.details.residentStatus === RESIDENT_STATUS.UNREGISTERED.value) {
                    if (!roomToResidentDetails.details.hasekoId) {
                        // 未登録かつ長谷工ID紐づけ未実施ユーザ
                        editUser = 'unRegisteredNotHasekoId'
                    } else {
                        // 未登録かつ長谷工ID紐づけ実施ユーザ
                        editUser = 'unRegisteredHasekoId'
                    }
                } else {
                    // 登録済ユーザ
                    editUser = 'registered'
                }

                // 登録ボタンの活性制御
                switch (editUser) {
                    case 'unRegisteredNotHasekoId':
                        registerButtonDisabled = true
                        break
                    case 'unRegisteredHasekoId':
                        registerButtonDisabled = !roomToResidentDetails.details.roleId ||
                            !roomToResidentDetails.details.familyName ||
                            !roomToResidentDetails.details.firstName ||
                            !roomToResidentDetails.details.familyNameKana ||
                            !roomToResidentDetails.details.firstNameKana ||
                            (!roomToResidentDetails.details.mailAddressPc &&
                                !roomToResidentDetails.details.mailAddressMb)
                        break
                    case 'registered':
                        registerButtonDisabled = !roomToResidentDetails.details.roleId ||
                            !roomToResidentDetails.details.familyName ||
                            !roomToResidentDetails.details.firstName ||
                            !roomToResidentDetails.details.familyNameKana ||
                            !roomToResidentDetails.details.firstNameKana ||
                            !roomToResidentDetails.details.birthday ||
                            !roomToResidentDetails.details.sex ||
                            (!roomToResidentDetails.details.mailAddressPc &&
                                !roomToResidentDetails.details.mailAddressMb)
                        break
                }

                if (this.state.selectedCondominiumCardKey === HAVE_OR_NOT.HAVE.value &&
                    !roomToResidentDetails.details.cardKeyNumber) {
                    // カードキーあり物件かつカードキー番号が存在しない場合、ボタン非活性
                    registerButtonDisabled = true
                }

                this.setState({
                    roomToResidentDetails: roomToResidentDetails,
                    mainUserFlag: mainUserFlag,
                    selectedRole: roomToResidentDetails.details.roleId,
                    cardKeyNumber: roomToResidentDetails.details.cardKeyNumber,
                    familyName: roomToResidentDetails.details.familyName,
                    firstName: roomToResidentDetails.details.firstName,
                    familyNameKana: roomToResidentDetails.details.familyNameKana,
                    firstNameKana: roomToResidentDetails.details.firstNameKana,
                    sex:
                        (roomToResidentDetails.details.sex) ?
                            roomToResidentDetails.details.sex :
                            SEX_MASTER.UNKNOWN.value,
                    mailAddressPc: roomToResidentDetails.details.mailAddressPc,
                    mailAddressMb: roomToResidentDetails.details.mailAddressMb,
                    adminFamilyName: roomToResidentDetails.details.adminFamilyName,
                    adminFirstName: roomToResidentDetails.details.adminFirstName,
                    adminFamilyNameKana: roomToResidentDetails.details.adminFamilyNameKana,
                    adminFirstNameKana: roomToResidentDetails.details.adminFirstNameKana,
                    validPeriodStartDate: roomToResidentDetails.details.validPeriodStartDate,
                    validPeriodEndDate: roomToResidentDetails.details.validPeriodEndDate,
                    birthday: roomToResidentDetails.details.birthday,
                    sutekiNetOfNotice:
                        (roomToResidentDetails.details.sutekiNetOfNotice) ?
                            roomToResidentDetails.details.sutekiNetOfNotice :
                            NOTIFICATION_DO_OR_NOT.NOTICE.value,
                    bulletinBoardCommentNotice:
                        (roomToResidentDetails.details.bulletinBoardCommentNotice) ?
                            roomToResidentDetails.details.bulletinBoardCommentNotice :
                            NOTIFICATION_DO_OR_NOT.NOTICE.value,
                    billingAmountFixNotice:
                        (roomToResidentDetails.details.billingAmountFixNotice) ?
                            roomToResidentDetails.details.billingAmountFixNotice :
                            NOTIFICATION_DO_OR_NOT.NOTICE.value,
                    facilityReserveAvailability:
                        (roomToResidentDetails.details.facilityReserveAvailability) ?
                            roomToResidentDetails.details.facilityReserveAvailability :
                            AVAILABLE_OR_NOT.AVAILABLE.value,
                    authenticationKey: roomToResidentDetails.details.authenticationKey,
                    registerButtonDisabled: registerButtonDisabled,
                    passwordPlaceholder: (roomToResidentDetails.details.mailAddressPc ||
                        roomToResidentDetails.details.mailAddressMb) ?
                        true : false,
                    editUser: editUser,
                    isLoadCompleted: true,
                    memo: roomToResidentDetails.details.memo,
                })
            }
            // 物件カードキー連携フラグを設定する
            const condominiumResponse: Nullable<NatGetCondominium> = await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominium.bind(
                    this.props.condominiumRepo, this.props.condominiumCd,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (condominiumResponse && condominiumResponse.details) {
                this.setState({
                    selectedCondominiumCardKey: condominiumResponse.details.cardKey,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 登録ボタンの表示・非表示制御
    setInputOrSelectState(
        inputOrSelectStateKey?: inputOrSelectState,
        inputOrSelectStateValue?: string,
    ): void {
        const inputOrSelectData: { [key: string]: string; } = {}
        inputOrSelectData.selectedRole = this.state.selectedRole
        inputOrSelectData.cardKeyNumber = this.state.cardKeyNumber
        inputOrSelectData.familyName = this.state.familyName
        inputOrSelectData.firstName = this.state.firstName
        inputOrSelectData.familyNameKana = this.state.familyNameKana
        inputOrSelectData.firstNameKana = this.state.firstNameKana
        inputOrSelectData.sex = this.state.sex
        inputOrSelectData.birthday = this.state.birthday
        inputOrSelectData.mailAddressPc = this.state.mailAddressPc
        inputOrSelectData.mailAddressMb = this.state.mailAddressMb
        inputOrSelectData.password = this.state.password
        inputOrSelectData.passwordConfirm = this.state.passwordConfirm
        inputOrSelectData.adminFamilyName = this.state.adminFamilyName
        inputOrSelectData.adminFirstName = this.state.adminFirstName
        inputOrSelectData.adminFamilyNameKana = this.state.adminFamilyNameKana
        inputOrSelectData.adminFirstNameKana = this.state.adminFirstNameKana
        inputOrSelectData.sutekiNetOfNotice = this.state.sutekiNetOfNotice
        inputOrSelectData.bulletinBoardCommentNotice = this.state.bulletinBoardCommentNotice
        inputOrSelectData.billingAmountFixNotice = this.state.billingAmountFixNotice
        inputOrSelectData.facilityReserveAvailability = this.state.facilityReserveAvailability
        inputOrSelectData.memo = this.state.memo
        let registerButtonDisabled: boolean = this.state.registerButtonDisabled

        if (inputOrSelectStateKey && inputOrSelectStateValue !== undefined) {
            // パラメータで上書き
            inputOrSelectData[inputOrSelectStateKey] = inputOrSelectStateValue

            // フリガナ設定
            switch (inputOrSelectStateKey) {
                case 'familyName':
                    inputOrSelectData.familyNameKana = inputOrSelectStateValue ? this.state.convertFamilyNameKana : ''
                    break
                case 'firstName':
                    inputOrSelectData.firstNameKana = inputOrSelectStateValue ? this.state.convertFirstNameKana : ''
                    break
                case 'adminFamilyName':
                    inputOrSelectData.adminFamilyNameKana =
                        inputOrSelectStateValue ? this.state.convertAdminFamilyNameKana : ''
                    break
                case 'adminFirstName':
                    inputOrSelectData.adminFirstNameKana =
                        inputOrSelectStateValue ? this.state.convertAdminFirstNameKana : ''
                    break
                default:
                    break
            }
        }

        switch (this.state.editUser) {
            case 'unRegisteredNotHasekoId':
                registerButtonDisabled = !(inputOrSelectData.selectedRole &&
                    inputOrSelectData.familyName &&
                    inputOrSelectData.firstName &&
                    inputOrSelectData.familyNameKana &&
                    inputOrSelectData.firstNameKana &&
                    (inputOrSelectData.mailAddressPc || inputOrSelectData.mailAddressMb) &&
                    inputOrSelectData.password &&
                    inputOrSelectData.passwordConfirm &&
                    inputOrSelectData.facilityReserveAvailability)
                break
            case 'unRegisteredHasekoId':
                registerButtonDisabled = !(inputOrSelectData.selectedRole &&
                    inputOrSelectData.familyName &&
                    inputOrSelectData.firstName &&
                    inputOrSelectData.familyNameKana &&
                    inputOrSelectData.firstNameKana &&
                    (inputOrSelectData.mailAddressPc || inputOrSelectData.mailAddressMb) &&
                    inputOrSelectData.facilityReserveAvailability)
                break
            case 'registered':
                registerButtonDisabled = !(inputOrSelectData.selectedRole &&
                    inputOrSelectData.familyName &&
                    inputOrSelectData.firstName &&
                    inputOrSelectData.familyNameKana &&
                    inputOrSelectData.firstNameKana &&
                    inputOrSelectData.sex &&
                    inputOrSelectData.birthday &&
                    (inputOrSelectData.mailAddressPc || inputOrSelectData.mailAddressMb) &&
                    inputOrSelectData.facilityReserveAvailability)
                break
        }

        if (this.state.selectedCondominiumCardKey === HAVE_OR_NOT.HAVE.value &&
            !inputOrSelectData.cardKeyNumber) {
            // カードキーあり物件かつカードキー番号が存在しない場合、ボタン非活性
            registerButtonDisabled = true
        }

        if (this.state.warnings.length > 0 && !this.state.acceptAll) {
            registerButtonDisabled = true
        }

        this.setState({
            selectedRole: inputOrSelectData.selectedRole,
            cardKeyNumber: inputOrSelectData.cardKeyNumber,
            familyName: inputOrSelectData.familyName,
            firstName: inputOrSelectData.firstName,
            familyNameKana: inputOrSelectData.familyNameKana,
            firstNameKana: inputOrSelectData.firstNameKana,
            sex: inputOrSelectData.sex,
            birthday: inputOrSelectData.birthday,
            mailAddressPc: inputOrSelectData.mailAddressPc,
            mailAddressMb: inputOrSelectData.mailAddressMb,
            password: inputOrSelectData.password,
            passwordConfirm: inputOrSelectData.passwordConfirm,
            adminFamilyName: inputOrSelectData.adminFamilyName,
            adminFirstName: inputOrSelectData.adminFirstName,
            adminFamilyNameKana: inputOrSelectData.adminFamilyNameKana,
            adminFirstNameKana: inputOrSelectData.adminFirstNameKana,
            sutekiNetOfNotice: inputOrSelectData.sutekiNetOfNotice,
            bulletinBoardCommentNotice: inputOrSelectData.bulletinBoardCommentNotice,
            billingAmountFixNotice: inputOrSelectData.billingAmountFixNotice,
            facilityReserveAvailability: inputOrSelectData.facilityReserveAvailability,
            registerButtonDisabled: registerButtonDisabled,
            memo: inputOrSelectData.memo,
        })
    }

    onChangeSelectRole(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('selectedRole', event.target.value)
    }

    onChangeSelectSex(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('sex', event.target.value)
    }

    onChangeSelectSutekiNetOfNotice(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('sutekiNetOfNotice', event.target.value)
    }

    onChangeBulletinBoardCommentNotice(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('bulletinBoardCommentNotice', event.target.value)
    }

    onChangeBillingAmountFixNotice(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('billingAmountFixNotice', event.target.value)
    }

    onChangeSelectFacilityReserveAvailability(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('facilityReserveAvailability', event.target.value)
    }

    onChangecardKeyNumber(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('cardKeyNumber', event.target.value)
    }

    onChangeBirthday(date: Nullable<Date>): void {
        if (date !== null) {
            this.setInputOrSelectState('birthday', date.toString())
        } else {
            this.setInputOrSelectState('birthday', '')
        }
    }

    onChangefamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('familyName', event.target.value)
    }

    onChangefirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('firstName', event.target.value)
    }

    onChangefamilyNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('familyNameKana', event.target.value)
    }

    onChangefirstNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('firstNameKana', event.target.value)
    }

    onChangeMailAddressPc(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('mailAddressPc', event.target.value)
    }

    onChangeMailAddressMb(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('mailAddressMb', event.target.value)
    }

    onChangepassword(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('password', event.target.value)
        if (!event.target.value) {
            this.setState({passwordConfirm: ''})
        }
    }

    onChangepasswordConfirm(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('passwordConfirm', event.target.value)
    }

    onChangeadminFamilyName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('adminFamilyName', event.target.value)
    }

    onChangeadminFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('adminFirstName', event.target.value)
    }

    onChangeadminFamilyNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('adminFamilyNameKana', event.target.value)
    }

    onChangeadminFirstNameKana(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setInputOrSelectState('adminFirstNameKana', event.target.value)
    }

    onChangeValidPeriodStartDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({validPeriodStartDate: date.toString()})
        } else {
            this.setState({validPeriodStartDate: ''})
        }
    }

    onChangeValidPeriodEndDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({validPeriodEndDate: date.toString()})
        } else {
            this.setState({validPeriodEndDate: ''})
        }
    }

    onChangeMemo(event: React.ChangeEvent<HTMLTextAreaElement>): void {
        this.setInputOrSelectState('memo', event.target.value as string)
    }

    onChangeAcceptedWarnings(acceptAll: boolean, acceptedWarning: AcceptedWarning[]): void {
        this.setState({
            acceptAll: acceptAll,
            acceptedWarning: acceptedWarning,
        }, () => {
            this.setInputOrSelectState()
        })
    }

    onCompositionStartFamilyName(): void {
        this.setState({
            convertFamilyNameKana: '',
            preFamilyNameKana: this.state.familyNameKana ?? '',
        })
    }

    onCompositionUpdateFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFamilyNameKana: this.state.preFamilyNameKana + kana})
        })
    }

    onCompositionStartFirstName(): void {
        this.setState({
            convertFirstNameKana: '',
            preFirstNameKana: this.state.firstNameKana ?? '',
        })
    }

    onCompositionUpdateFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertFirstNameKana: this.state.preFirstNameKana + kana})
        })
    }

    onCompositionStartAdminFamilyName(): void {
        this.setState({
            convertAdminFamilyNameKana: '',
            preAdminFamilyNameKana: this.state.adminFamilyNameKana ?? '',
        })
    }

    onCompositionUpdateAdminFamilyName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertAdminFamilyNameKana: this.state.preAdminFamilyNameKana + kana})
        })
    }

    onCompositionStartAdminFirstName(): void {
        this.setState({
            convertAdminFirstNameKana: '',
            preAdminFirstNameKana: this.state.adminFirstNameKana ?? '',
        })
    }

    onCompositionUpdateAdminFirstName(event: React.CompositionEvent<HTMLInputElement>): void {
        autoKanaOnUpdate(event.data, (kana) => {
            this.setState({convertAdminFirstNameKana: this.state.preAdminFirstNameKana + kana})
        })
    }

    residentUserListLinkClick(): void {
        this.props.navigate(`/admin/residentUser/${this.props.condominiumCd}/${this.props.ridgeCd}/${this.props.roomNumber}/${this.props.seq}`,
        )
    }

    // 登録ボタン押下
    async registerResidentUser(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString('居住者ユーザ'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.clearBroadcastedErrors()
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        try {
            if (this.state.roomToResidentDetails &&
                this.state.roomToResidentDetails.details) {
                const request: NatPutRoomToResidentParams = {
                    condominiumCd: this.props.condominiumCd,
                    ridgeCd: this.props.ridgeCd,
                    roomNumber: this.props.roomNumber,
                    seq: Number(this.props.seq),
                    cardKeyNumber: this.state.cardKeyNumber,
                    familyName: this.state.familyName,
                    firstName: this.state.firstName,
                    familyNameKana: this.state.familyNameKana,
                    firstNameKana: this.state.firstNameKana,
                    sex: this.state.sex,
                    birthday: this.state.birthday ? formatForDateInput(this.state.birthday) : '',
                    mailAddressPc: this.state.mailAddressPc,
                    mailAddressMb: this.state.mailAddressMb,
                    adminFamilyName: this.state.adminFamilyName,
                    adminFirstName: this.state.adminFirstName,
                    adminFamilyNameKana: this.state.adminFamilyNameKana,
                    adminFirstNameKana: this.state.adminFirstNameKana,
                    validPeriodStartDate: this.state.validPeriodStartDate ?
                        formatForDateInput(this.state.validPeriodStartDate) : '',
                    validPeriodEndDate: this.state.validPeriodEndDate ?
                        formatForDateInput(this.state.validPeriodEndDate) : '',
                    password: this.state.password,
                    checkPassword: this.state.passwordConfirm,
                    sutekiNetOfNotice: this.state.sutekiNetOfNotice,
                    bulletinBoardCommentNotice: this.state.bulletinBoardCommentNotice,
                    billingAmountFixNotice: this.state.billingAmountFixNotice,
                    facilityReserveAvailability: this.state.facilityReserveAvailability,
                    residentUserVersion: this.state.roomToResidentDetails.details.residentUserVersion,
                    roomToResidentVersion: this.state.roomToResidentDetails.details.roomToResidentVersion,
                    adminUserVersions: this.state.roomToResidentDetails.details.adminUserVersions,
                    memo: this.state.memo,
                }

                if (this.state.authenticationKey) {
                    if (!request.sex) {
                        request.sex = null
                    }
                    if (!request.birthday) {
                        request.birthday = null
                    }
                }

                if (this.state.mainUserFlag) {
                    request.roleId = this.state.selectedRole ? this.state.selectedRole : ''
                }

                if (this.state.acceptedWarning.length > 0) {
                    request.permissionWarning = this.state.acceptedWarning
                }

                // 居住者ユーザ更新
                const response: Nullable<NatPutRoomToResident> = await this.props.asyncCallFunction(
                    this.props.roomToResidentRepo.putRoomToResidentForAdmin.bind(
                        this.props.roomToResidentRepo, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0002.toString('居住者ユーザ')},
                )

                if (response !== null && response.requestError === null) {
                    if (response.informations !== null) {
                        this.setState({warnings: getAcceptedWarningList(response.informations)},
                            () => {
                                this.setInputOrSelectState()
                            })
                    } else {
                        let detailMessage: string = Messages.IOPCC0008.toString('居住者ユーザ')
                        if (response.details.rejectionRegistrationApplyInfoList.length) {
                            detailMessage = detailMessage + '\n' +
                                createRejectionResidentUserRegistrationApplyInfoMessage(
                                    response.details.rejectionRegistrationApplyInfoList)
                        }
                        this.props.navigate(`/admin/residentUser/${this.props.condominiumCd}/${this.props.ridgeCd}/${this.props.roomNumber}/${this.props.seq}`,
                            {
                                state: {
                                    initialMessage: {
                                        title: null,
                                        messageLevel: MESSAGE_TYPE.INFORMATION,
                                        detail: detailMessage,
                                    },
                                },
                            },
                        )
                    }
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 権限
    getRoleMasterRadioGroupData(): PPRadioItemProp[] {
        return ROLE_FOR_RESIDENT.values().map((role) => (
            {
                label: role.label,
                value: role.value,
                radioProps: {
                    autoFocus: (role.value === this.state.selectedRole),
                    onChange: this.onChangeSelectRole,
                    checked: role.value === this.state.selectedRole,
                },
            }
        ))
    }

    // 性別
    getSexRadioGroupData(): PPRadioItemProp[] {

        const sexRadioGroupData: PPRadioItemProp[] = []
        SEX_MASTER.values().map((sex) => (
            sexRadioGroupData.push(
                {
                    label: sex.label,
                    value: sex.value,
                    radioProps: {
                        onChange: this.onChangeSelectSex,
                        checked: sex.value === this.state.sex,
                    },
                },
            )
        ))
        return sexRadioGroupData

    }

    // 素敵ネットからの通知
    getSutekiNetOfNoticeRadioGroupData(): PPRadioItemProp[] {

        const sutekiNetOfNoticeRadioGroupData: PPRadioItemProp[] = []
        MAIL_MAGAZINE_RECEIVING_DO_OR_NOT.values().map((sutekiNetOfNotic) => (
            sutekiNetOfNoticeRadioGroupData.push(
                {
                    label: sutekiNetOfNotic.label,
                    value: sutekiNetOfNotic.value,
                    radioProps: {
                        onChange: this.onChangeSelectSutekiNetOfNotice,
                        checked: sutekiNetOfNotic.value === this.state.sutekiNetOfNotice,
                    },
                },
            )
        ))
        return sutekiNetOfNoticeRadioGroupData

    }

    // 情報交換掲示板コメント
    getBulletinBoardCommentNoticeRadioGroupData(): PPRadioItemProp[] {
        const bulletinBoardCommentNoticeRadioGroupData: PPRadioItemProp[] = []
        NOTIFICATION_DO_OR_NOT.values().map((bulletinBoardCommentNotice) => (
            bulletinBoardCommentNoticeRadioGroupData.push(
                {
                    label: bulletinBoardCommentNotice.label,
                    value: bulletinBoardCommentNotice.value,
                    radioProps: {
                        onChange: this.onChangeBulletinBoardCommentNotice,
                        checked: bulletinBoardCommentNotice.value === this.state.bulletinBoardCommentNotice,
                    },
                },
            )
        ))
        return bulletinBoardCommentNoticeRadioGroupData

    }

    // ご請求金額の確定通知
    getBillingAmountFixNoticeRadioGroupData(): PPRadioItemProp[] {
        const billingAmountFixNoticeRadioGroupData: PPRadioItemProp[] = []
        NOTIFICATION_DO_OR_NOT.values().map((billingAmountFixNotice) => (
            billingAmountFixNoticeRadioGroupData.push(
                {
                    label: billingAmountFixNotice.label,
                    value: billingAmountFixNotice.value,
                    radioProps: {
                        onChange: this.onChangeBillingAmountFixNotice,
                        checked: billingAmountFixNotice.value === this.state.billingAmountFixNotice,
                    },
                },
            )
        ))
        return billingAmountFixNoticeRadioGroupData

    }

    // 施設予約可否
    getFacilityReserveAvailabilityRadioGroupData(): PPRadioItemProp[] {
        const facilityReserveAvailabilityRadioGroupData: PPRadioItemProp[] = []
        AVAILABLE_OR_NOT.values().map((facilityReserveAvailability) => (
            facilityReserveAvailabilityRadioGroupData.push(
                {
                    label: facilityReserveAvailability.label,
                    value: facilityReserveAvailability.value,
                    radioProps: {
                        onChange: this.onChangeSelectFacilityReserveAvailability,
                        checked: facilityReserveAvailability.value ===
                            this.state.facilityReserveAvailability,
                    },
                },
            )
        ))
        return facilityReserveAvailabilityRadioGroupData

    }

    renderInputFormTable(): ReactNode {
        if (this.state.roomToResidentDetails && this.state.roomToResidentDetails.details) {
            return (
                <>

                    <ConditionTableFixed>
                        <colgroup>
                            <col width={'25%'}/>
                            <col width={'15%'}/>
                            <col width={'20%'}/>
                            <col width={'20%'}/>
                            <col width={'20%'}/>
                        </colgroup>
                        <StyledTableCaption>居住者ユーザ情報</StyledTableCaption>
                        <TableBody>
                            <TableRow>
                                {(this.state.mainUserFlag) ?
                                    <>
                                        <TableRowName required>権限</TableRowName>
                                        <TableCell colSpan={4}>
                                            <PPRadioGroup
                                                row
                                                data={this.getRoleMasterRadioGroupData()}
                                                eventKeys={['roleId']}
                                                eventEmitter={this.props.eventEmitter}
                                            />
                                        </TableCell>
                                    </> :
                                    <>
                                        <TableRowName>権限</TableRowName>
                                        <TableCell colSpan={4}>
                                            {this.state.roomToResidentDetails.details.roleName}
                                        </TableCell>
                                    </>
                                }
                            </TableRow>
                            {(this.administratorMode === ADMINISTORATOR_MODE.ALL.value) ?
                                <>
                                    <TableRow>
                                        <TableRowName>物件グループ</TableRowName>
                                        <TableCell colSpan={4}>
                                            {this.state.roomToResidentDetails.details.condominiumGroupName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableRowName>物件名</TableRowName>
                                        <TableCell colSpan={4}>
                                            {this.state.roomToResidentDetails.details.condominiumName}
                                        </TableCell>
                                    </TableRow>
                                </> : null
                            }
                            <TableRow>
                                <TableRowName>棟名</TableRowName>
                                <TableCell colSpan={4}>
                                    {this.state.roomToResidentDetails.details.ridgeCd +
                                        ' : ' + this.state.roomToResidentDetails.details.ridgeName}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>部屋番号</TableRowName>
                                <TableCell colSpan=
                                               {this.state.selectedCondominiumCardKey ===
                                               HAVE_OR_NOT.HAVE.value ? 2 : 4}>
                                    {this.state.roomToResidentDetails.details.roomNumber}
                                </TableCell>
                                {this.state.selectedCondominiumCardKey === HAVE_OR_NOT.HAVE.value &&
                                    <>
                                        {(this.state.mainUserFlag) ?
                                            <>
                                                <TableRowName required>カードキー番号</TableRowName>
                                                <TableCell colSpan={2}>
                                                    <PPTextField
                                                        InputProps={{
                                                            inputProps: {
                                                                maxLength: 10,
                                                            },
                                                        }}
                                                        required
                                                        fullWidth
                                                        value={this.state.cardKeyNumber}
                                                        onChange={this.onChangecardKeyNumber}
                                                        eventKeys={['cardKeyNumber']}
                                                        eventEmitter={this.props.eventEmitter}
                                                    />
                                                </TableCell>
                                            </> :
                                            <>
                                                <TableRowName>カードキー番号</TableRowName>
                                                <TableCell colSpan={2}>
                                                    {this.state.cardKeyNumber}
                                                </TableCell>
                                            </>

                                        }
                                    </>
                                }
                            </TableRow>
                            <TableRow>
                                <TableRowName required>氏名</TableRowName>
                                <TableCell colSpan={2}>
                                    姓
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'familyName',
                                                id: 'familyName',
                                                maxLength: 10,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onInput={this.onChangefamilyName}
                                        onChange={this.onChangefamilyName}
                                        value={this.state.familyName}
                                        eventKeys={['familyName']}
                                        eventEmitter={this.props.eventEmitter}
                                        onCompositionStart={this.onCompositionStartFamilyName}
                                        onCompositionUpdate={this.onCompositionUpdateFamilyName}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}>
                                    名
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'firstName',
                                                id: 'firstName',
                                                maxLength: 10,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onInput={this.onChangefirstName}
                                        onChange={this.onChangefirstName}
                                        value={this.state.firstName}
                                        eventKeys={['firstName']}
                                        eventEmitter={this.props.eventEmitter}
                                        onCompositionStart={this.onCompositionStartFirstName}
                                        onCompositionUpdate={this.onCompositionUpdateFirstName}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName required>氏名（フリガナ）</TableRowName>
                                <TableCell colSpan={2}>
                                    セイ
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'familyNameKana',
                                                id: 'familyNameKana',
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onInput={this.onChangefamilyNameKana}
                                        onChange={this.onChangefamilyNameKana}
                                        value={this.state.familyNameKana}
                                        eventKeys={['familyNameKana']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}>
                                    メイ
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'firstNameKana',
                                                id: 'firstNameKana',
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onInput={this.onChangefirstNameKana}
                                        onChange={this.onChangefirstNameKana}
                                        value={this.state.firstNameKana}
                                        eventKeys={['firstNameKana']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                {(this.state.authenticationKey) ?
                                    <TableRowName>性別</TableRowName> :
                                    <TableRowName required>性別</TableRowName>
                                }
                                <TableCell colSpan={2}>
                                    <PPRadioGroup
                                        row
                                        data={this.getSexRadioGroupData()}
                                        eventKeys={['sex']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                                {(this.state.authenticationKey) ?
                                    <TableRowName>生年月日</TableRowName> :
                                    <TableRowName required>生年月日</TableRowName>
                                }
                                <TableCell colSpan={1}>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeBirthday}
                                        value={(this.state.birthday !== '' && this.state.birthday !== null) ?
                                            new Date(this.state.birthday) : null}
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['birthday']}
                                    />
                                </TableCell>
                                <TableCell colSpan={1}></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName required rowSpan={1}>メールアドレス</TableRowName>
                                <TableCell colSpan={4}>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'mailAddressPc',
                                                id: 'mailAddressPc',
                                                maxLength: 100,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onChange={this.onChangeMailAddressPc}
                                        value={this.state.mailAddressPc}
                                        eventKeys={['mailAddressPc']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                {(this.state.editUser === 'unRegisteredNotHasekoId') ?
                                    <TableRowName required>パスワード</TableRowName> :
                                    <TableRowName>パスワード</TableRowName>
                                }
                                <TableCell colSpan={4}>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'password',
                                                id: 'password',
                                                maxLength: 20,
                                                type: 'password',
                                            },
                                        }}
                                        required
                                        autoComplete={'new-password'}
                                        placeholder={
                                            (!this.state.passwordPlaceholder) ?
                                                '' : '●●●●●●●●●●'}
                                        fullWidth
                                        onChange={this.onChangepassword}
                                        value={this.state.password}
                                        eventKeys={['password']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                {(this.state.editUser === 'unRegisteredNotHasekoId') ?
                                    <TableRowName required>パスワード（確認用）</TableRowName> :
                                    <TableRowName>パスワード（確認用）</TableRowName>
                                }
                                <TableCell colSpan={4}>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'passwordConfirm',
                                                id: 'passwordConfirm',
                                                maxLength: 20,
                                                type: 'password',
                                            },
                                        }}
                                        required
                                        autoComplete={'new-password'}
                                        placeholder={
                                            (!this.state.passwordPlaceholder) ?
                                                '' : '●●●●●●●●●●'}
                                        fullWidth
                                        onChange={this.onChangepasswordConfirm}
                                        value={this.state.passwordConfirm}
                                        disabled={!this.state.password}
                                        eventKeys={['passwordConfirm']}
                                        eventEmitter={this.props.eventEmitter}
                                        sx={{
                                            '& .MuiInputBase-input.Mui-disabled': {
                                                backgroundColor: '#DDD',
                                            },
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>管理者確認用氏名</TableRowName>
                                <TableCell colSpan={2}>
                                    姓
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'adminFamilyName',
                                                id: 'adminFamilyName',
                                                maxLength: 10,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onInput={this.onChangeadminFamilyName}
                                        onChange={this.onChangeadminFamilyName}
                                        value={this.state.adminFamilyName}
                                        eventKeys={['adminFamilyName']}
                                        eventEmitter={this.props.eventEmitter}
                                        onCompositionStart={this.onCompositionStartAdminFamilyName}
                                        onCompositionUpdate={this.onCompositionUpdateAdminFamilyName}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}>
                                    名
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'adminFirstName',
                                                id: 'adminFirstName',
                                                maxLength: 10,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onInput={this.onChangeadminFirstName}
                                        onChange={this.onChangeadminFirstName}
                                        value={this.state.adminFirstName}
                                        eventKeys={['adminFirstName']}
                                        eventEmitter={this.props.eventEmitter}
                                        onCompositionStart={this.onCompositionStartAdminFirstName}
                                        onCompositionUpdate={this.onCompositionUpdateAdminFirstName}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>管理者確認用氏名(フリガナ)</TableRowName>
                                <TableCell colSpan={2}>
                                    セイ
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'adminFamilyNameKana',
                                                id: 'adminFamilyNameKana',
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onInput={this.onChangeadminFamilyNameKana}
                                        onChange={this.onChangeadminFamilyNameKana}
                                        value={this.state.adminFamilyNameKana}
                                        eventKeys={['adminFamilyNameKana']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                                <TableCell colSpan={2}>
                                    メイ
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                name: 'adminFirstNameKana',
                                                id: 'adminFirstNameKana',
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onInput={this.onChangeadminFirstNameKana}
                                        onChange={this.onChangeadminFirstNameKana}
                                        value={this.state.adminFirstNameKana}
                                        eventKeys={['adminFirstNameKana']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>有効期間開始日</TableRowName>
                                <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 21.5}}>
                                    {(this.state.mainUserFlag) ?
                                        <PPDatePicker
                                            onChangeDate={this.onChangeValidPeriodStartDate}
                                            value={(this.state.validPeriodStartDate) ?
                                                new Date(this.state.validPeriodStartDate) : null}
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={['validPeriodStartDate']}
                                        /> :
                                        <>
                                            {this.state.validPeriodStartDate}
                                        </>
                                    }
                                </TableCell>
                                <TableRowName>有効期間終了日</TableRowName>
                                <TableCell colSpan={2} style={{paddingBottom: 18, paddingTop: 21.5}}>
                                    {(this.state.mainUserFlag) ?
                                        <PPDatePicker
                                            onChangeDate={this.onChangeValidPeriodEndDate}
                                            value={(this.state.validPeriodEndDate) ?
                                                new Date(this.state.validPeriodEndDate) : null}
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={['validPeriodEndDate']}
                                        /> :
                                        <>
                                            {this.state.validPeriodEndDate}
                                        </>
                                    }
                                </TableCell>
                            </TableRow>
                            {(this.state.mainUserFlag) ? null :
                                <>
                                    <TableRow>
                                        <TableRowName>メインユーザ</TableRowName>
                                        <TableCell colSpan={4}>
                                            {getStringOrEmptyString(
                                                this.state.roomToResidentDetails.details.parentFamilyName)}
                                            {' '}
                                            {getStringOrEmptyString(
                                                this.state.roomToResidentDetails.details.parentFirstName)}
                                            {(this.state.roomToResidentDetails.details.parentFamilyNameKana ||
                                                this.state.roomToResidentDetails.details.parentFirstNameKana) ?
                                                ' (' + getStringOrEmptyString(
                                                    this.state.roomToResidentDetails.details.parentFamilyNameKana) +
                                                ' ' + getStringOrEmptyString(
                                                    this.state.roomToResidentDetails.details.parentFirstNameKana)
                                                + ')' : ''
                                            }
                                        </TableCell>
                                    </TableRow>
                                </>
                            }
                            <TableRow>
                                <TableRowNameTop rowSpan={3}>メール受信設定</TableRowNameTop>
                                <StyledTableCell colSpan={4}>
                                    ご請求金額の確定通知
                                    <PPRadioGroup
                                        row
                                        data={this.getBillingAmountFixNoticeRadioGroupData()}
                                        eventKeys={['billingAmountFixNotice']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </StyledTableCell>
                            </TableRow>

                            <TableRow>
                                <StyledTableCell colSpan={4}>
                                    情報交換掲示板のコメント通知
                                    <PPRadioGroup
                                        row
                                        data={this.getBulletinBoardCommentNoticeRadioGroupData()}
                                        eventKeys={['bulletinBoardCommentNotice']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledTableCell colSpan={4}>
                                    すてきテラスのメールマガジン
                                    <PPRadioGroup
                                        row
                                        data={this.getSutekiNetOfNoticeRadioGroupData()}
                                        eventKeys={['sutekiNetOfNotice']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </StyledTableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName required>施設予約可否</TableRowName>
                                <TableCell colSpan={4}>
                                    <PPRadioGroup
                                        row
                                        data={this.getFacilityReserveAvailabilityRadioGroupData()}
                                        eventKeys={['facilityReserveAvailability']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName>メモ</TableRowName>
                                <TableCell colSpan={4}>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                maxLength: 2000,
                                                minRows: 3,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        multiline
                                        value={this.state.memo}
                                        onChange={this.onChangeMemo}
                                        eventKeys={['memo']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </ConditionTableFixed>
                </>
            )
        }
    }


    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.state.registerButtonDisabled}
                        onClick={this.registerResidentUser}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.residentUserListLinkClick}
                    >
                        居住者ユーザ詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                </PageMainArea>
                <Box height={16}/>
                <NatAdminCommonAcceptedWarningComponent
                    warnings={setHighlightingWarningList(highlightingMessegIdList, this.state.warnings)}
                    changeAcceptedWarnings={this.onChangeAcceptedWarnings}
                    doOpenAnimation={true}
                />
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminResidentUserEditPage)

const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    padding-bottom: 8px;
  }
`
